/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Triggers } from './Triggers';
import {
    TriggersFromJSON,
    TriggersFromJSONTyped,
    TriggersToJSON,
} from './Triggers';

/**
 * 
 * @export
 * @interface ExecRiskAylienNewsOverviewEntry
 */
export interface ExecRiskAylienNewsOverviewEntry {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAylienNewsOverviewEntry
     */
    entity: string;
    /**
     * 
     * @type {Triggers}
     * @memberof ExecRiskAylienNewsOverviewEntry
     */
    triggers: Triggers;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskAylienNewsOverviewEntry
     */
    triggers_count: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskAylienNewsOverviewEntry
     */
    positive_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskAylienNewsOverviewEntry
     */
    negative_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskAylienNewsOverviewEntry
     */
    neutral_count?: number;
}

/**
 * Check if a given object implements the ExecRiskAylienNewsOverviewEntry interface.
 */
export function instanceOfExecRiskAylienNewsOverviewEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entity" in value;
    isInstance = isInstance && "triggers" in value;
    isInstance = isInstance && "triggers_count" in value;

    return isInstance;
}

export function ExecRiskAylienNewsOverviewEntryFromJSON(json: any): ExecRiskAylienNewsOverviewEntry {
    return ExecRiskAylienNewsOverviewEntryFromJSONTyped(json, false);
}

export function ExecRiskAylienNewsOverviewEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskAylienNewsOverviewEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity': json['entity'],
        'triggers': TriggersFromJSON(json['triggers']),
        'triggers_count': json['triggers_count'],
        'positive_count': !exists(json, 'positive_count') ? undefined : json['positive_count'],
        'negative_count': !exists(json, 'negative_count') ? undefined : json['negative_count'],
        'neutral_count': !exists(json, 'neutral_count') ? undefined : json['neutral_count'],
    };
}

export function ExecRiskAylienNewsOverviewEntryToJSON(value?: ExecRiskAylienNewsOverviewEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity': value.entity,
        'triggers': TriggersToJSON(value.triggers),
        'triggers_count': value.triggers_count,
        'positive_count': value.positive_count,
        'negative_count': value.negative_count,
        'neutral_count': value.neutral_count,
    };
}

